import EnviromentConfig from "../../configs/enviromentConfig";
const API_URL = EnviromentConfig.API_URL;

export const api = {
      suministro: {
        async addSupply(data) {
            const res = await fetch(`${API_URL}/api/suministro`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token"),
                },
                body: JSON.stringify(data),
            });

            const body = await res.json().catch(() => null);

            if (!res.ok) {
                const err = new Error(body?.error || "Error inesperado del servidor");
                err.status = res.status;
                err.payload = body;
                throw err;
            }

            return body;
            },
        async getByUsuario(usuarioId) {
            const res = await fetch(`${API_URL}/api/suministro/usuario/${usuarioId}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        },
        async getServiciosBySuministro(suministroid) {
            const res = await fetch(`${API_URL}/api/suministro/${suministroid}/servicios`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        },
        async bajaSuministro(idSuministro) {
            const res = await fetch(`${API_URL}/api/suministro/${idSuministro}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token"),
            },
            body: JSON.stringify({
                baja: new Date().toISOString(), 
            }),
            });

            const body = await res.json().catch(() => null);

            if (!res.ok) {
            const err = new Error(body?.error || "Error al desasociar suministro");
            err.status = res.status;
            throw err;
            }

            return body;
        },
     },
facturas: {
            async getFacturasSuministro(suministroId, CliCod) {
            const res = await fetch(`${API_URL}/api/facturas/${suministroId}/${CliCod}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        }
},
     pdf: {
        async getPDF(prefix) {
            const res = await fetch(`${API_URL}/api/pdf?prefix=${prefix}`, {
                method: "GET",
                headers: { 
                Authorization: localStorage.getItem('token'),
                },
            });

            if (!res.ok) throw await res.json();

            return await res.blob(); // ← devuelve el PDF como archivo
            }
        },
  }